import AppAPI from "../../api/app.js";
import provinces from "./provinces.js";
import cities from "./cities.js";

export const app = {
    namespaced: true,

    state: {
        user: {},
        fullscreen: false,
        provinces: provinces,
        cities: cities
    },

    actions: {
        USER: async ({ commit }) =>
            AppAPI.user().then(response => {
                commit("USER", response.data);
            })
    },

    mutations: {
        USER: (state, user) => state.user = user,
    },
    getters: {
        group: state => group =>
            state.user.groups != undefined &&
            state.user.group.indexOf(group) > -1
    }
};
